export default __webpack_public_path__ + "static/media/6.e83364d3.jpeg";